import { useState } from "react";
import { Check, Gift, Lock } from "lucide-react";
import { Reveal } from "@/components/store/Reveal";
import { BuyButton } from "@/components/store/BuyButton";
import { GiftDialog } from "@/components/store/GiftDialog";
import { PRODUCT } from "@/constants/product";

const includes = [
  "The full Meal Planning and Grocery Systems workbook (PDF)",
  "A weekly routine for checking what you have before you shop",
  "Space to plan meals and build a focused grocery list",
  "A simple way to log and track grocery spending",
];

export const BuyPanel = () => {
  const [gift, setGift] = useState(false);
  return (
  <section id="buy" className="mx-auto max-w-[1360px] px-5 py-24 sm:px-10 sm:py-32" data-testid="offer-section">
    <Reveal>
      <div className="grid overflow-hidden rounded-md border border-black/20 bg-[var(--paper)] lg:grid-cols-[0.9fr_1.1fr]">
        <div className="flex items-center justify-center bg-[var(--sage)] p-10 sm:p-16">
          <img src={PRODUCT.cover} alt="Workbook cover" className="cover-tilt w-full max-w-[300px] rounded-sm border border-black/20 shadow-[0_40px_60px_-30px_rgba(23,20,15,0.6)]" data-testid="offer-cover-image" />
        </div>
        <div className="p-8 sm:p-14">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[var(--sage-deep)]">What you get</p>
          <h2 className="font-display mt-5 text-4xl leading-[1.02] sm:text-5xl">Everything for your weekly grocery system.</h2>
          <ul className="mt-10 space-y-4">
            {includes.map((t) => (
              <li key={t} className="flex gap-3 text-[var(--muted)]">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[var(--sage)]"><Check className="h-3 w-3" /></span>{t}
              </li>
            ))}
          </ul>
          <div className="mt-12 flex flex-wrap items-end justify-between gap-6 border-t border-black/15 pt-8">
            <div>
              <p className="text-xs uppercase tracking-[0.18em] text-[var(--muted)]">One-time price</p>
              <p className="font-display text-6xl sm:text-7xl" data-testid="offer-price">{PRODUCT.price}</p>
            </div>
            <div className="flex flex-wrap items-center gap-3">
              <button onClick={() => setGift(true)} className="inline-flex items-center gap-2 rounded-full border border-black/25 px-6 py-4 font-semibold transition-colors hover:bg-[var(--sage)]" data-testid="offer-gift-button">
                <Gift className="h-4 w-4" /> Buy as a gift
              </button>
              <BuyButton label="Pay & download" testId="offer-buy-button" />
            </div>
          </div>
          <p className="mt-6 flex items-center gap-2 text-sm text-[var(--muted)]"><Lock className="h-3.5 w-3.5" /> Secure card checkout by Stripe. Your download unlocks right after payment.</p>
        </div>
      </div>
    </Reveal>
    <GiftDialog open={gift} onOpenChange={setGift} />
  </section>
  );
};
